export const getAllUsersData = () => {
    return async dispatch => {
        await authAxios().get('/user/all').then(response => {
            dispatch({
                type: 'GET_ALL_DATA',
                data: response?.data?.resultObject[0]?.filter(item => item.isDeleted === false)
            })
        })
    }
}

// ** Initial State
const initialState = {
    popupImages: []

}

const popup = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_POPUP_IMAGES':
            console.log(action.payload)
            return { ...state, popupImages: action.payload }
        default:
            return { ...state }
    }
}
export default popup